import { accountsModuleI18n } from "@/modules/accounts";
import { authModuleI18n } from "@/modules/auth";
import { organizationModuleI18n } from "@/modules/organization";
import { partnersModuleI18n } from "@/modules/partners";
import { shopModuleI18n } from "@/modules/shop";
import { commonModuleI18n } from "@/modules/common";
import { eventsModuleI18n } from "@/modules/events";
import { consultantModuleI18n } from "@/modules/consultant";
import { NFTsModuleI18n } from "@/modules/NFT";
import { dataModuleI18n } from "@/modules/data";
import { errorModuleI18n } from "@/modules/error";
import { profileModuleI18n } from "@/modules/profile";
import { projectsModuleI18n } from "@/modules/projects";
import { userModuleI18n } from "@/modules/user";
import { webModuleI18n } from "@/modules/web";
import { servicesModuleI18n } from "@/modules/services";
import { blogModuleI18n } from "@/modules/blog";
import { trainingModuleI18n } from "@/modules/training";

export const en = {
  auth: authModuleI18n.en,
  shop: shopModuleI18n.en,
  accounts: accountsModuleI18n.en,
  partners: partnersModuleI18n.en,
  organization: organizationModuleI18n.en,
  common: commonModuleI18n.en,
  events: eventsModuleI18n.en,
  consultant: consultantModuleI18n.en,
  data: dataModuleI18n.en,
  error: errorModuleI18n.en,
  profile: profileModuleI18n.en,
  projects: projectsModuleI18n.en,
  user: userModuleI18n.en,
  web: webModuleI18n.en,
  NFTs: NFTsModuleI18n.en,
  services: servicesModuleI18n.en,
  blog: blogModuleI18n.en,
  training: trainingModuleI18n.en
};
